module.exports = __webpack_public_path__ + "static/media/walkawhileCropped.b9705727.png";